(function(ns) {
	"use strict";

	ns.app = null;

	Vue.filter("number", function(val) {
		if (typeof val === "number") {
			return val.toLocaleString();
		} else {
			return val;
		}
	});

	function initApp(rootE) {
		ns.app = new Vue({
			el: rootE,
			data: function() {
				return {
					valid_post: ""
				};
			},
			mounted: function() {
				// DOM を描画した直後に呼ばれる
				var me = this;

				[].forEach.call(me.$el.querySelectorAll(".js-loading"), function(el) {
					el.parentNode.removeChild(el);
				});

				me.valid_post = me.$el.querySelector("input[type='hidden']").value;
			}
		});
		return ns.app;
	}

	BS.GoogleMaps.ready(function(googlemaps) {
		ns.store.apis.googlemaps = googlemaps;
	});

	ns.initApp = initApp;

})(CE);
